const record = (v) => typeof v === 'object' && v !== null;
export function isInstitutionalDocumentHistory(v, org, actId) {
    return (record(v) &&
        v.schemaVersion === 1 &&
        v.testOnly === true &&
        v.organizationId === org &&
        Array.isArray(v.items) &&
        v.items.every((r) => record(r) &&
            r.organizationId === org &&
            r.actId === actId &&
            ['id', 'fileName', 'sha256', 'uploadedAt', 'reason'].every((k) => typeof r[k] === 'string') &&
            /^[0-9a-f]{64}$/.test(String(r.sha256)) &&
            Number.isInteger(r.version) &&
            Number(r.version) > 0 &&
            Number.isInteger(r.sizeBytes) &&
            Number(r.sizeBytes) > 0 &&
            Number(r.sizeBytes) <= 20971520 &&
            ['preserved', 'upload'].includes(String(r.origin))));
}
